import { render, staticRenderFns } from "./AgentRatings.vue?vue&type=template&id=36ff8ad5"
import script from "./AgentRatings.vue?vue&type=script&lang=js"
export * from "./AgentRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports